






















































































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';

import { mapActions } from 'vuex';

import {
  CrudForm,
  KeywordsInput,
  ProductsSearch,
  RankedProducts,
  RegularFilterSelector,
  Tabs,
  UiButton,
  UiIcon,
  UiMenu
} from '../../components';

import { ApiEnum, DeviceEnum, FilterTypeEnum, GridDisplayEnum, ProductLayerEnum, ProductsSearchModesEnum } from '../../enums';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { Dictionary, Filter, RegularFilter } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { SEARCH_CONSTS } from '../../store/search/search.consts';

export default {
  name: 'products-ranking-form',
  components: {
    RankedProducts,
    CrudForm,
    KeywordsInput,
    ProductsSearch,
    RegularFilterSelector,
    UiButton,
    UiIcon,
    UiMenu,
    Tabs
  },
  mixins: [CrudFormMixin],
  created: function () {
    const filters: Dictionary<RegularFilter> = {};
    Object.values(this.context.filters)
      .filter((filter: Filter) => (filter.config.type === FilterTypeEnum.REGULAR))
      .forEach((filter: RegularFilter) => {
        filters[(filter.config.toolingId || filter.config.id)] = {
          config: {
            ...filter.config,
            mandatory: true,
            multiselectDisabled: true
          },
          selectedValues: [filter.config.values[0].id]
        };
      });
    this.searchFilters = filters;
  },
  computed: {
    filters: function (): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)();
      filters.lang.config.mandatory = true;
      return filters;
    },
    valid: function (): boolean {
      if (!this.item.filters.lang.length) {
        return false;
      }
      if (!this.item.keywords.length) {
        return false;
      }
      if (!this.item.elements.length) {
        return false;
      }
      return true;
    },
    searchFiltersAvailable: function () {
      if (this.selectedConfigMode === ProductsSearchModesEnum.SEARCH) {
        return Object.keys(this.searchFilters)
          .filter(filterKey => filterKey === 'lang')
          .reduce((siftFilters, siftKey) => {
            siftFilters[siftKey] = this.searchFilters[siftKey];
            return siftFilters;
          }, {});
      } else {
        return this.searchFilters;
      }
    },
    isHandheldDevice: function () {
      return this.$epb.device <= DeviceEnum.SMALL_TABLET;
    },
    showConfiguration: function () {
      return !!this.item.keywords.length && !!this.item.filters.lang.length;
    },
    configurationTabs: function () {
      return Object.values(ProductsSearchModesEnum)
        .filter(mode => (this.isHandheldDevice || mode !== ProductsSearchModesEnum.LIST))
        .map(modeFiltered => ({
          id: modeFiltered,
          icon: this.getProductsSearchModeIcon(modeFiltered),
          text: !this.isHandheldDevice ? this.getProductsSearchModeTitle(modeFiltered) : undefined
        }));
    },
    itemsPerRow: function () {
      const gridItems = {
        [DeviceEnum.DESKTOP]: {
          [GridDisplayEnum.BIG]: 3,
          [GridDisplayEnum.SMALL]: 2
        },
        [DeviceEnum.MOBILE]: {
          [GridDisplayEnum.BIG]: 2,
          [GridDisplayEnum.SMALL]: 1
        },
        'default': {
          [GridDisplayEnum.BIG]: 4,
          [GridDisplayEnum.SMALL]: 3
        }
      };
      return (gridItems[this.$epb.device] || gridItems['default']);
    },
    searchLangs: function () {
      const filterValuesMessages = this.$epb.messages.filters.values[this.filters['lang'].config.id];
      return this.item.filters.lang.map(langId => ({
        value: langId,
        label: (langId.prettyName || (!!filterValuesMessages && filterValuesMessages[langId]) || langId)
      }));
    }
  },
  data: function () {
    const messages = this.$epb.messages.tools.productsRanking;
    return {
      dataType: ActionTypeEnum.PRODUCTS_RANKING,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.productsRanking.update),
      item: {
        enabled: true,
        keywords: [],
        elements: [],
        filters: {
          lang: []
        }
      },
      searchFilters: {},
      searchParams: {
        productsRankingField: '',
        productsRankingBoostsIds: '',
        productsRankingBuriesIds: ''
      },
      selectedConfigMode: '',
      lastProductWidgetShown: false,
      messages: messages,
      DeviceEnum,
      ProductsSearchModesEnum,
      GridDisplayEnum,
      ProductLayerEnum
    };
  },
  methods: {
    ...mapActions(SEARCH_CONSTS.moduleName, {
      search: SEARCH_CONSTS.actions.search
    }),
    updateProductsToBoost: function (productsSelected) {
      productsSelected.map((product) => {
        const productIndex = this.item.elements.findIndex((boostedProduct) => boostedProduct.fieldValue === product.fieldValue);
        if (productIndex !== -1) {
          this.item.elements.splice(productIndex, 1);
        } else {
          this.item.elements.unshift(product);
          this.lastProductWidgetShown = true;
          setTimeout(() => {
            this.lastProductWidgetShown = false;
          }, 1500);
        }
      });
    },
    onChangeSearchFilter: function (filter: { filterId: string, newValue: string[] }) {
      this.searchFiltersAvailable[filter.filterId].selectedValues = filter.newValue;
    },
    setSearchParams: function () {
      if (this.selectedConfigMode === ProductsSearchModesEnum.PREVIEW) {
        this.searchParams.productsRankingField = this.instanceConfig.catalog.resultMappings.id;
        this.searchParams.productsRankingBoostsIds = this.item.elements
          .filter((product) => product.action === RankingActionEnum.BOOST && this.isProductOnSelectedFilters(product))
          .map(filteredProduct => filteredProduct.fieldValue).join();
        this.searchParams.productsRankingBuriesIds = this.item.elements
          .filter((product) => product.action === RankingActionEnum.BURY)
          .map(filteredProduct => filteredProduct.fieldValue).join();
      } else {
        this.searchParams.productsRankingField = '';
        this.searchParams.productsRankingBoostsIds = '';
        this.searchParams.productsRankingBuriesIds = '';
      }
    },
    isProductOnSelectedFilters: function (product): boolean {
      return Object.values(this.searchFiltersAvailable).every((filter: RegularFilter) => {
        const productFilters = product.filters[(filter.config.toolingId || filter.config.id)];
        return (!productFilters || (productFilters.length === 0 ||
          productFilters.some(productFilterValue => filter.selectedValues.indexOf(productFilterValue) > -1)));
      });
    },
    onApplyUpdatesOnProducts: function (productsSelected) {
      productsSelected.map(productSelected => {
        const productToUpdate = this.item.elements.find(product => product.fieldValue === productSelected.fieldValue);
        Object.keys(productSelected.filters).forEach(key => {
          if (productSelected.filters[key].length === 0) {
            delete productToUpdate.filters[key];
          } else {
            productToUpdate.filters[key] = productSelected.filters[key];
          }
        });
        Object.keys(productSelected.schedule).forEach(scheduleKey => {
          productToUpdate.schedule[scheduleKey] = productSelected.schedule[scheduleKey];
        });
      });
    },
    getProductsSearchModeIcon: function (mode: ProductsSearchModesEnum): string {
      return {
        [ProductsSearchModesEnum.SEARCH]: 'search',
        [ProductsSearchModesEnum.PREVIEW]: 'preview',
        [ProductsSearchModesEnum.LIST]: 'boost'
      }[mode];
    },
    getProductsSearchModeTitle: function (mode: ProductsSearchModesEnum): string {
      return {
        [ProductsSearchModesEnum.SEARCH]: this.messages.products.titleSearch,
        [ProductsSearchModesEnum.PREVIEW]: this.messages.products.titlePreview,
        [ProductsSearchModesEnum.LIST]: this.messages.products.titleList
      }[mode];
    },
    fillInitSearchData: async function () {
      this.$emit('updateLoading', { visible: true });
      try {
        const searchResults = await this.search({
          query: this.item.elements.map(product => product.fieldValue).join(' '),
          filters: this.searchFiltersAvailable,
          pagination: { page: 1, itemsPerPage: this.item.elements.length },
          params: { mm: 1 }
        });
        searchResults.data.items.map(searchProduct => {
          const playProduct = this.item.elements.find(product => product.fieldValue === searchProduct.fieldValue);
          if (!!playProduct) {
            playProduct.imageUrl = searchProduct.imageUrl;
            playProduct.name = searchProduct.name;
          }
        });
        this.$emit('updateLoading', { visible: false });
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.SEARCH));
        this.$emit('updateLoading', { visible: false });
      }
    }
  },
  watch: {
    'item.id': function () {
      if (this.updateMode && this.item.elements.length > 0 && this.item.keywords.length > 0) {
        // TODO this.fillInitSearchData(); this should be on the new method onItemLoad (crud-mixin)
      }
    },
    'item.elements': {
      handler: function () {
        this.setSearchParams();
      },
      deep: true
    },
    'selectedConfigMode': function () {
      this.setSearchParams();
    },
    'searchFiltersAvailable': {
      handler: function () {
        this.setSearchParams();
      },
      deep: true
    }
  }
};

